import {Pipe, PipeTransform} from '@angular/core';
import {AddonPermissionService} from 'app/addon-permission/addon-permission.service';
import {Observable, of} from 'rxjs';
import {AddonKeys} from "../main/pages/addons/addons/addon-keys.enum";


@Pipe({
  name: 'addonPermission',
  standalone: true
})
 
/*
  * pipe use for addon permission
 */
export class AddonPermissionPipe implements PipeTransform {
  constructor(private permission: AddonPermissionService) { }
  transform(key: string): Observable<boolean> {
    const permissionAddons = [AddonKeys.CC, AddonKeys.GL, AddonKeys.IMS, AddonKeys.DK, AddonKeys.LH];
    return permissionAddons.includes(key as AddonKeys) ? this.permission.getAddonPermission(key) : of(true);
  }

}
